import { inject } from '@angular/core';
import { CanActivateFn, NavigationCancel, NavigationEnd, NavigationError, Router } from '@angular/router';
import { OnlinePlayStateService } from '@core/online-play/services/online-play-state.service';
import { filter, take } from 'rxjs';

export const connectGuard: CanActivateFn = () => {
    const onlinePlayStateService = inject(OnlinePlayStateService);
    const router = inject(Router);
    const navigationId = router.currentNavigation()?.id;
    const previouslyDisabled = onlinePlayStateService.disableGameplayEvents();

    // Authentication can connect the socket before the camera component initializes.
    onlinePlayStateService.disableGameplayEvents.set(true);

    router.events
        .pipe(
            filter(
                (event) =>
                    (event instanceof NavigationEnd ||
                        event instanceof NavigationCancel ||
                        event instanceof NavigationError) &&
                    event.id === navigationId
            ),
            take(1)
        )
        .subscribe((event) => {
            if (!(event instanceof NavigationEnd)) {
                onlinePlayStateService.disableGameplayEvents.set(previouslyDisabled);
            }
        });

    return true;
};
